import { useEffect, useState } from 'react';
import Footer from '../../../components/NextAndPrev';
import { NodeValidatorDataZoneTypes, DefaultStakingObjectType } from '../declaration';
import NodeCard from './NodeCard';

interface Props {
    first: boolean;
    prev: () => void;
    nextPage: () => void;
    countNode: number;
    setCountNode: (n: number) => void;
    nodeDataZone: NodeValidatorDataZoneTypes[];
    setNodeDataZone: (obj: any) => void;
    last: boolean;
    submit: () => void;
    defaultObject: DefaultStakingObjectType;
}

const AddNodes = ({
    first,
    prev,
    nextPage,
    countNode,
    setCountNode,
    nodeDataZone,
    setNodeDataZone,
    last,
    submit,
    defaultObject,
}: Props) => {
    const [nodeFlag, setNodeFlag] = useState<boolean>(false);

    useEffect(() => {
        // getUsername();
        AddNode();
    }, []);

    const getNewObject = () => {
        const nodeObj: NodeValidatorDataZoneTypes = {
            nodeName: defaultObject.nodeName,
            dashPass: defaultObject.dashPass,
            shmExtPort: defaultObject.shmExtPort,
            shmIntPort: defaultObject.shmIntPort,
            endpointEnabled: defaultObject.endpointEnabled,
            http: defaultObject.endpointEnabled ? defaultObject.http : false,
            ws: defaultObject.endpointEnabled ? defaultObject.ws : false,
            authUser: defaultObject.endpointEnabled ? defaultObject.authUser : '',
            authPassword: defaultObject.endpointEnabled ? defaultObject.authPassword : '',
        };
        return nodeObj;
    };

    // Adding node
    const AddNode = () => {
        const nodeObj = JSON.parse(JSON.stringify(getNewObject()));

        if (countNode === 0) {
            setNodeDataZone([nodeObj]);
        }
        setCountNode(1);
        // } else {
        //   let nodeArr = nodeDataZone.slice();
        //   nodeArr = [...nodeArr, nodeObj];
        //   setNodeDataZone(nodeArr);
        // }
    };
    const Node = () => {
        const cards = [];
        for (let i = 0; i < countNode; i += 1) {
            cards.push(
                <NodeCard
                    key={`node${i}`}
                    cardnumber={i}
                    nodeDataZone={nodeDataZone}
                    setNodeFlag={setNodeFlag}
                    setNodeDataZone={setNodeDataZone}
                    setNodeCount={setCountNode}
                    nodeCount={countNode}
                />,
            );
        }
        return cards;
    };

    const solve = () => {
        if (countNode === 0) {
            return true;
        }
        if (nodeFlag) {
            return false;
        }
        return true;
    };
    return (
        <>
            <div className=' col-11 mx-auto'>
                <div className=' mx-auto'>{Node()}</div>
            </div>

            {/* <Footer last={last} showNext={solve()} submit={submit} first={first} nextPage={nextPage} prev={prev} /> */}
            <Footer
                isLastPage={last}
                submit={solve}
                isFirstPage={first}
                nextPage={nextPage}
                prevPage={prev}
                nextDisabled={!nodeFlag}
                submitText='Create'
            />
        </>
    );
};
export default AddNodes;
